module.exports = __webpack_public_path__ + "static/img/cosmic_microwave_background.4faff7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cosmic_microwave_background.jpg
// module id = 7v1Y
// module chunks = 0